import { Factory } from 'fishery';
import { Integration } from '@trukt/types/Integration';

export const integrationFactory = Factory.define<Integration>(({ sequence }) => ({
  id: sequence.toString(),
  externalId: '123',
  externalInvoiceId: '456',
  invoiceGuid: '',
  referenceNumber: '789',
  externalAppId: '',
  exportedLines: 0,
  dateCreated: '2022-08-26T20:13:57.940Z',
  dateUpdated: '2022-08-26T20:13:57.940Z',
  status: 'FAILURE',
  errorMessage: 'Invoice not found.',
  app: {
    name: 'NETSUITE',
    id: '123',
    status: '',
    isEnabled: true,
    errorMessage: null,
    dateConnectionCheck: null,
  },
}));
